module.exports = __webpack_public_path__ + "static/heinz-0d8369454f0c84138459e6866e1733b2.png";